import {lockr, Mutation, React, Redirect, RouteComponentProps, Sentry, uiConstants, withRouter} from '@api'
import {authStore} from '@utils'
import {LOGIN_MUTATION, LoginComponent} from '../'
import {Severity} from '@sentry/types';
import {configs, cc, deployments, globalStores} from '@stores'
import {observable} from 'mobx';

interface MyProps extends RouteComponentProps<{}> {
}

@(withRouter as any)
export class Login extends React.Component<MyProps> {
  @observable loginContext: { username?: string, password?: string } = {}

  render() {
    const {authStore: {onLoginSuccess, checkIsAuthenticated}, deployments} = globalStores

    // if (userIsAuthenticated) {
    //   return <Redirect to={'/'}/>
    // }

    return (
      <Mutation mutation={LOGIN_MUTATION} context={{skipAuth: true}}>
        {((login, {data, error, loading}) => {
          if (error) {
            Sentry.addBreadcrumb({category: 'auth', level: Severity.Warning, message: `Failed to login user '${this.loginContext.username}'`, data: {error}})
            authStore.isLoggingIn = false
          }

          return <LoginComponent
            onSubmit={e => {
              this.loginContext = e.variables
              authStore.isLoggingIn = true
              DEBUG && console.debug(`Logging in to deployment ${deployments.selectedDeploymentId} as ${e.variables.username}`)

              return login(e)
            }}
            error={error}
            onLoginSuccess={r => setTimeout(() => onLoginSuccess(r), 0)}
          />
        }) as any}
      </Mutation>
    )
  }
}




// WEBPACK FOOTER //
// ./src/modules/login/containers/Login.tsx